import PropTypes from "prop-types";
import Echeancier from "app/pages/.shared/Echeancier/Echeancier";
import { getEcheancierCasino } from "app/pages/Booking/Payment/paymentSelector";
import { getQuoteTotalWithDelta } from "app/pages/Booking/bookingSelectors";
import { connect } from "react-redux";

const EcheancierCasinoContainer = ({ apport, mensualite, coutCredit, prixVente }) => {
	return (
		<Echeancier
			mensualite={mensualite}
			apport={apport}
			coutCredit={coutCredit}
			prixVente={prixVente}
			mensualiteCount={4}
			paymentPartner={"FLOA"}
		/>
	);
};

EcheancierCasinoContainer.propTypes = {
	apport: PropTypes.number,
	mensualite: PropTypes.number,
	prixVente: PropTypes.number,
	coutCredit: PropTypes.number,
};

const mapStateToProps = state => {
	const mensualite = getEcheancierCasino(state);

	return {
		apport: mensualite.apport,
		mensualite: mensualite.mensualite,
		coutCredit: mensualite.coutCredit,
		prixVente: getQuoteTotalWithDelta(state),
	};
};

export default connect(mapStateToProps)(EcheancierCasinoContainer);
